export function openOAuthPopup(app, attrs) {
  const fullscreen = app.forum.attribute('fof-oauth.fullscreenPopup');
  if (fullscreen) {
    window.open(app.forum.attribute('baseUrl') + attrs.path, 'logInPopup', 'fullscreen=yes');
  } else {
    var _$$height, _$$width;
    const defaultWidth = 580;
    const defaultHeight = 400;
    const width = app.forum.attribute('fof-oauth.popupWidth') || defaultWidth;
    const height = app.forum.attribute('fof-oauth.popupHeight') || defaultHeight;
    const windowHeight = (_$$height = $(window).height()) != null ? _$$height : 0;
    const windowWidth = (_$$width = $(window).width()) != null ? _$$width : 0;
    const top = windowHeight / 2 - height / 2;
    const left = windowWidth / 2 - width / 2;
    window.open(app.forum.attribute('baseUrl') + attrs.path, 'logInPopup', "width=".concat(width, ",") + "height=".concat(height, ",") + "top=".concat(top, ",") + "left=".concat(left, ",") + 'status=no,scrollbars=yes,resizable=no');
  }
}
flarum.reg.add('fof-oauth', 'forum/utils/popupUtils', { openOAuthPopup: openOAuthPopup, });